<!-- eslint-disable max-len -->
<template>
<svg
    width="140" height="140" viewBox="0 0 140 140"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <circle
        cx="70" cy="70" r="70"
        fill="currentColor"
        class="circle-inner"
    />
    <path d="M57.9,42c-2-1.3-4.6-1.3-6.7-0.1c-2.1,1.2-3.4,3.4-3.4,5.8V96c0,2.4,1.3,4.6,3.4,5.8c2.1,1.2,4.6,1.1,6.7-0.1l39.6-24.2 c2-1.2,3.2-3.3,3.2-5.6c0-2.3-1.2-4.4-3.2-5.6L57.9,42z" fill="black" />
</svg>
</template>
